import React, { useCallback, useEffect, useState } from "react";
import { Button } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { baseUrl } from "../../Config/baseUrl";

const Blog = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const deleteBlog = (id) => {
    axios
      .delete(`${baseUrl}/blog/blog-api/`, {
        data: { blog_id: id },
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        if (response.data.response_code === 200) {
          toast.success(response.data.message);
          blogData();
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        console.log("Error deleting blog", err);
      });
  };

  const blogData = useCallback(() => {
    localStorage.getItem("token") ? navigate("/blog") : navigate("/");
    axios
      .get(`${baseUrl}/blog/blog-api/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      })
      .then((res) => {
        setData(res?.data?.data || []);
      })
      .catch((err) => {
        console.log("ERROR:", err);
        toast.error(err?.message);
      });
  }, [navigate]);

  useEffect(() => {
    blogData();
  }, [blogData]);

  return (
    <div className="px-3 md:px-6">
      {/* Page Title */}
      <p className="my-4 sm:my-0 text-3xl md:text-5xl text-center text-blue-900 underline">
        Blog
      </p>

      {/* Add Button */}
      <div className="flex justify-end mb-2">
        <NavLink to="/addblog">
          <Button variant="outlined">Add Blog</Button>
        </NavLink>
      </div>

      {/* Blog List */}
      <div className="space-y-4">
        {data?.map((item, idx) => (
          <div
            key={idx}
            className="
              grid grid-cols-1 md:grid-cols-3
              gap-4
              border border-gray-300 rounded-lg shadow
              p-4
            "
          >
            {/* Blog Content */}
            <div className="flex flex-col justify-center">
              <p className="text-xl md:text-2xl font-semibold text-black">
                {item.title}
              </p>
              <p className="text-sm md:text-base text-gray-700 mt-2">
                {item.meta_description}
              </p>
            </div>

            {/* Image */}
            <div className="flex justify-center items-center">
              <img
                src={`${item.images}?${Date.now()}`}
                alt="blog"
                className="w-32 h-32 md:w-40 md:h-40 object-cover rounded"
              />
            </div>

            {/* Actions */}
            <div className="flex justify-center md:justify-end items-center gap-3">
              <Button
                onClick={() => navigate("/updateblog", { state: item.id })}
                variant="outlined"
                size="small"
              >
                Update
              </Button>

              <Button
                onClick={() => deleteBlog(item.id)}
                variant="outlined"
                size="small"
                color="error"
              >
                Delete
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Blog;
